import { Box, IconButton } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import HeartBrokenIcon from '@mui/icons-material/HeartBroken';
import { useGetCurrentUser } from '../../hooks/auth.ts';
import {
  useMutateAddFavorite,
  useMutateDeleteFavorite,
  useMutateDeleteHomeDesign,
  useMutateDeleteHomeModelFavorite,
  useMutateSaveHomeModelFavorite,
} from '../../api/favorites';
import {
  FavoriteProperties,
  HomeModelFavoriteProperties,
} from '../../models/favorites.model';
import './FavoriteButton.scss';
import { useEffect, useState } from 'react';
import { AccountRequiredModal } from '../../components/account-required-modal/account-required-modal.tsx';
import { extractIdOfSK } from '../../utils/search.ts';
interface FavoriteButtonProps {
  result?: FavoriteProperties;
  saveHomeModelResult?: HomeModelFavoriteProperties;
  homeModelFavorites?: HomeModelFavoriteProperties[];
  favorites?: FavoriteProperties[];
  id: string;
  addtoFavoritesFunc?: () => void;
  isfavoriteHomeDesign?: boolean;
}

export const FavoriteButton = (props: FavoriteButtonProps) => {
  const {
    homeModelFavorites,
    saveHomeModelResult,
    result,
    favorites,
    id,
    addtoFavoritesFunc,
    isfavoriteHomeDesign,
  } = props;
  const [hovered, setHovered] = useState(false);
  // Flag to determine if we should favorite the property once the user logs in
  const [pendingRequest, setpendingRequest] = useState(false);

  let isFavorite: boolean = false;
  if (favorites) {
    isFavorite = favorites?.some((f) => f.id === id) || false;
  } else if (homeModelFavorites) {
    isFavorite =
      homeModelFavorites?.some((item) => extractIdOfSK(item.sk) === id) ||
      false;
  } else if (isfavoriteHomeDesign) {
    isFavorite = isfavoriteHomeDesign;
  }

  const { data: user } = useGetCurrentUser();
  const addMutation = useMutateAddFavorite();
  const deleteMutation = useMutateDeleteFavorite(user?.userId || '');

  const addMutationHomeModelFavorite = useMutateSaveHomeModelFavorite();
  const deleteMutationHomeModelFavorite = useMutateDeleteHomeModelFavorite();
  const deleteMutationHomeDesign = useMutateDeleteHomeDesign();

  const favoriteProperty = () => {
    if (isFavorite && favorites) {
      deleteMutation.mutate(id);
    } else {
      if (result) {
        addMutation.mutate({
          sub: user?.userId || '',
          id: id,
          latitude: result.latitude,
          longitude: result.longitude,
          apn: result.apn,
          address: result.address,
        });
        if (addtoFavoritesFunc) addtoFavoritesFunc();
      }
      if (isFavorite && homeModelFavorites && !isfavoriteHomeDesign) {
        deleteMutationHomeModelFavorite.mutate(id);
      } else {
        if (saveHomeModelResult) {
          addMutationHomeModelFavorite.mutate({
            homeModelId: id,
          });
          if (addtoFavoritesFunc) addtoFavoritesFunc();
        }
      }
    }
    if (isfavoriteHomeDesign) {
      deleteMutationHomeDesign.mutate(id);
    }
  };

  const [openAccountRequiredModal, setOpenAccountRequiredModal] =
    useState(false);

  const onClick = () => {
    if (user?.userId) {
      setOpenAccountRequiredModal(false);
      favoriteProperty();
      setpendingRequest(false);
    } else {
      setOpenAccountRequiredModal(true);
      setpendingRequest(true);
    }
    setHovered(false);
  };

  // Subscribing to user login. Finish the favorite request when the user is logged in
  // TODO: Is it possible to avoid useEffect here?
  useEffect(() => {
    if (user?.userId && pendingRequest) {
      setOpenAccountRequiredModal(false);
      favoriteProperty();
      setpendingRequest(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.userId, isFavorite]);

  return (
    <Box>
      {!user?.userId && openAccountRequiredModal && pendingRequest && (
        <AccountRequiredModal
          open={openAccountRequiredModal}
          onClose={() => setOpenAccountRequiredModal(false)}
        />
      )}

      <IconButton
        disabled={addMutation.isPending || deleteMutation.isPending}
        aria-label="favorite"
        color="primary"
        className="favorite-button"
        data-is-favorite={isFavorite}
        onClick={() => {
          onClick();
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        sx={{ borderRadius: '0px' }}
      >
        <div className="button-tooltip">
          {!isFavorite ? 'Favorite' : 'Unfavorite'}
        </div>
        {isFavorite && hovered ? (
          <HeartBrokenIcon sx={{ color: 'white' }} />
        ) : (
          <FavoriteIcon sx={{ color: isFavorite ? 'white' : '#49454F' }} />
        )}
      </IconButton>
    </Box>
  );
};
